module.exports = __webpack_public_path__ + "static/media/nf.1b0c4057.svg";